import Box from '@mui/material/Box'
import DialogContent from '@mui/material/DialogContent'
import Drawer from '@mui/material/Drawer'
import Modal from '@mui/material/Modal'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Image from 'next/image'
import { memo } from 'react'

import ModalLayout from '@/components/common/ModalLayout'
import useTrans from '@/hooks/useTrans'

type ViewProps = {
  isOpen: boolean
  isDesktop: boolean
  isDepositing: boolean
  onClose: () => void
  onClick: (methodType: string) => void
  methodOptions: {
    title: string
    description: string
    type: string
    dataTestID: string
    icon: string
  }[]
}

const View = ({ isOpen, isDesktop, isDepositing, onClose, methodOptions, onClick }: ViewProps) => {
  const trans = useTrans()

  const renderedContent = (
    <ModalLayout
      title={isDepositing ? trans.common.deposit : trans.common.withdraw}
      isInsideDrawer={!isDesktop}
      onClose={onClose}
    >
      <Stack gap="8px">
        {methodOptions.map((method) => (
          <Stack
            key={method.type}
            gap="8px"
            direction="row"
            alignItems="center"
            className="bg-[#141A23] py-5 px-4 rounded-lg cursor-pointer"
            onClick={() => onClick(method.type)}
            data-testid={method.dataTestID}
          >
            <Image
              alt={method.title}
              src={method.icon}
              className="object-cover"
              width={40}
              height={40}
            />
            <Box className="flex-1">
              <Typography className="text-base font-semibold">{method.title}</Typography>
              <Typography className="text-[#9CA3AE] text-sm">{method.description}</Typography>
            </Box>
          </Stack>
        ))}
      </Stack>
    </ModalLayout>
  )

  if (isDesktop) {
    return (
      <Modal open={isOpen} data-testid="method-selection-modal">
        <DialogContent className="outline-none">{renderedContent}</DialogContent>
      </Modal>
    )
  }

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      anchor="bottom"
      sx={{
        '.MuiPaper-elevation': {
          backgroundColor: 'transparent',
          backgroundImage: 'none',
        },
      }}
      data-testid="method-selection-drawer"
    >
      {renderedContent}
    </Drawer>
  )
}

export default memo(View)
